export default "__VITE_ASSET__0a3c1020__"